export const UNIT_LIST_V3_CHUNK_SIZE = 100;
export const UNIT_LIST_V3_ITEM_TYPE = "unit-v3";
export const UNIT_LIST_V3_WEB_ROOT_MARGIN = "280px 0px";

